module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-User-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('hamv-info-box', {
    attrs: {
      "title": _vm.$t('userInfoBoxTitleUsersText'),
      "total": _vm.total.users || '--',
      "classes": "fa fa-user"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-search"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:4|max:50'),
      expression: "'min:4|max:50'"
    }],
    attrs: {
      "placeholder": _vm.$t('userInputSearchBarPlaceholder'),
      "clearable": "",
      "name": "searchQuery",
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.userSearch(_vm.searchQuery)
      }
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "disabled": _vm.errors.has('searchQuery'),
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        _vm.userSearch(_vm.searchQuery)
      }
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('searchQuery')),
      expression: "errors.has('searchQuery')"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.$t('userInputSearchBarError')))])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    ref: "userListTable",
    staticClass: "user-table",
    attrs: {
      "element-loading-text": _vm.$t('userTableLoadingText'),
      "empty-text": _vm.$t('userTableEmptyText'),
      "expand-row-keys": _vm.expanded,
      "data": _vm.userList,
      "row-key": _vm.getRowKey,
      "data-qa": "Content-User-Table",
      "element-loading-background": "#FFFFFF",
      "fit": "",
      "max-height": "100%",
      "row-class-name": "pointer",
      "show-header": ""
    },
    on: {
      "expand-change": _vm.handleExpand,
      "row-click": _vm.toggleRowExpansion
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('user-info', {
          attrs: {
            "user": _vm.userInfo,
            "loading": _vm.isLoadingInfo
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('userTableColEmailLabel'),
      "sortable": "",
      "prop": "email",
      "min-width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('userTableColRegisteredTimeLabel'),
      "min-width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.convertTime(scope.row.creation_date)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('userTooltipDeleteText'),
            "effect": "dark",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "data-qa": 'Content-DeleteUser-Button-' + scope.row.id,
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteUser(scope.row.id, scope.row.email)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash fa-2 operation-icons"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.showPagination) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pagination.currentPage,
      "disabled": _vm.isLoading,
      "layout": _vm.pagination.layout,
      "page-size": _vm.pagination.limit,
      "total": _vm.searchedTotal,
      "background": ""
    },
    on: {
      "update:currentPage": function($event) {
        _vm.$set(_vm.pagination, "currentPage", $event)
      },
      "current-change": _vm.getCurrentPageUser
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('user-delete')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7474bac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/User.vue
// module id = 980
// module chunks = 3